import React from 'react'

import styles from './trendingSash.module.css'

export const TrendingItem = () => {
  return (
    <span className={styles.trending}>
      Trending
    </span>
  )
}

export default TrendingItem



// WEBPACK FOOTER //
// ./client/components/itemCard/common/trendingSash.js